import script from "./DetalharCobranca.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalharCobranca.vue?vue&type=script&setup=true&lang=js"

import "./DetalharCobranca.vue?vue&type=style&index=0&id=7021c117&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7021c117"]])

export default __exports__